import { css } from '@emotion/react'
import React from 'react'
import { SummaryLabel } from './OverseasCompanySummary'
import { OverseasCompanyData } from '../../../../../types/api'
import { colors, font } from 'plume-ui'
import { Help } from '../../../../common/Help'
import { DateNote } from '../domestic/CompanySummary'
import { formatLastFundingType } from '@/lib/roundtype'

type Props = {
  className?: string
  company: OverseasCompanyData
}

export const RoundType: React.VFC<Props> = (props) => {
  return (
    <div
      className={props.className}
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
      `}
    >
      <SummaryLabel>
        最新ラウンドタイプ
        <Help
          className="help"
          linkTo="https://help.initial.inc/ja/articles/5489432"
          css={css`
            vertical-align: bottom;
          `}
        >
          定義を見る
        </Help>
      </SummaryLabel>
      <div
        className="value"
        css={css`
          display: flex;
          height: 48px;
          font-style: normal;
          font-weight: ${font.weight.normal};
          font-size: 22px;
          line-height: 100%;
          align-items: center;
          text-align: center;
          color: ${colors.black10};
        `}
      >
        {props.company.lastFundingType == null
          ? '-'
          : formatLastFundingType(props.company.lastFundingType.type)}
      </div>
      <DateNote
        className="date"
        date={
          props.company.lastFundingType && props.company.lastFundingType.date
        }
        suffix="時点"
      />
    </div>
  )
}
